import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutocompleteSettingsComponent } from 'app/account/settings/autocomplete-settings/autocomplete-settings.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-autocomplete-settings-dialog',
  standalone: true,
  imports: [CommonModule, AutocompleteSettingsComponent, MatDialogModule, MatIconModule, MatButtonModule],
  templateUrl: './autocomplete-settings-dialog.component.html',
  styleUrl: './autocomplete-settings-dialog.component.scss'
})
export class AutocompleteSettingsDialogComponent {

  settings = new Set<string>(['numberFormat', 'documentsSymbols', 'numberingType'])
  constructor(private _dialog: MatDialogRef<AutocompleteSettingsDialogComponent>) {}

  close() {
    this._dialog.close()
  }
}
